export { default } from './FileUploader.vue';
